module.exports = __webpack_public_path__ + "static/media/profile.4da4ad21.png";